// Multiplier to get non-leasable percentage from cart total
const NON_LEASABLE_MULTIPLIER = 0.3;
//Non-leasable items percentage
const NON_LEASABLE_PERCENTAGE = '30%';

export { NON_LEASABLE_PERCENTAGE, NON_LEASABLE_MULTIPLIER };
